document.addEventListener("DOMContentLoaded", function () {
    var subMenus = document.querySelectorAll('.sub-menu');
    for (var i = 0; i < subMenus.length; i++) {
        subMenus[i].style.display = 'none';
    }

    var menuItems = document.querySelectorAll('.menu-item-has-children > a');
    for (var i = 0; i < menuItems.length; i++) {
        menuItems[i].addEventListener('click', function (event) {
            event.preventDefault();
            var subMenu = this.nextElementSibling;
            if (subMenu.style.display === 'block') {
                subMenu.style.display = 'none';
            } else {
                subMenu.style.display = 'block';
            }
        });
    }
});
